import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './index.css';

// Only use StrictMode in development to avoid double rendering in production
const app = (
  <Provider store={store}>
    <App />
  </Provider>
);

const rootElement = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootElement);

if (import.meta.env.DEV) {
  root.render(
    <React.StrictMode>
      {app}
    </React.StrictMode>
  );
} else {
  root.render(app);
}